import { Menu } from 'lucide-react';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { useIsMobile } from '@/hooks/use-mobile';
interface NavBarProps {
  onSignOut?: () => void;
  isAuthenticated?: boolean;
}
const NavBar = ({
  onSignOut,
  isAuthenticated
}: NavBarProps) => {
  const isMobile = useIsMobile();
  return <div className="w-full border-b bg-white shadow-sm fixed top-0 z-40">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-bold text-primary">ERP CoPilot AI</h1>

          <div className="flex items-center gap-4">
            {isMobile && <SidebarTrigger>
                <Menu className="h-6 w-6 text-gray-700 hover:text-gray-900" />
              </SidebarTrigger>}
          </div>
        </div>
      </div>
    </div>;
};
export default NavBar;